/* eslint-disable */
import React, { Component } from 'react';
import './App.css';
import Swing, { Stack, Card, Direction } from 'react-swing';
import ReactDOM from 'react-dom';
import $ from 'jquery'
import {  browserHistory  } from 'react-router'
import cookie from 'react-cookies'
import MetaTags from 'react-meta-tags';
import {baseURL,cmsURL} from './config';

// relative path to image 
import menu from './images/menu.png';
import upload from './images/upload.png';
import AI_1 from './images/AI_1.png';
import AI_2 from './images/AI_2.png';
import AI_3 from './images/AI_3.png';
import AI_4 from './images/AI_4.png';
import AI_5 from './images/AI_5.png';
import AI_6 from './images/AI_6.png';
import AI_7 from './images/AI_7.png';
import AI_8 from './images/AI_8.png';
import AI_9 from './images/AI_9.png';
import AI_10 from './images/AI_10.png';
import AI_11 from './images/AI_11.png';
import AI_12 from './images/AI_12.png';
import AI_13 from './images/AI_13.png';
import AI_14 from './images/AI_14.png';
import AI_15 from './images/AI_15.png';
import AI_16 from './images/AI_16.png';
import AI_17 from './images/AI_17.png';
import AI_18 from './images/AI_18.png';
import AI_19 from './images/AI_19.png';
import AI_20 from './images/AI_20.png';

class Home extends Component {
	
	stack = React.createRef();
	constructor(props, context) {
      super(props, context);
      // An instance of the Stack
      this.state = {
		  stack: null,
		  left:0,
		  right:0,
		  total:0,
		  totalavailable:20,
		  nextTarget:'',
		  realMatters:0,
		  delightful:0,
		  beauty:0,
		  lifeStyle:0,
	  };
	  
	  var params = this.props.params;	  
	  if(params.lang==undefined){
		browserHistory.push('/masj/en');
	  }

  }
 

    componentDidMount(){
		
		
		/*Share */
		/*---Email---*/
		var eTo = encodeURI("quiz@example.com");
		var eSubj = encodeURI("MASJ Discovery Quiz");
		var eBody = encodeURI("MASJ Discovery Quiz");
		var email = "mailto:" + eTo + "?subject=" + eSubj + "&body=" + eBody;
		document.getElementById("result01").href = email;
	
		window.fbAsyncInit = function() {
			FB.init({
			  appId      : '145473506239948',
			  xfbml      : true,
			  version    : 'v2.4'
			});
		  };
		  
		  (function(d, s, id){
			 var js, fjs = d.getElementsByTagName(s)[0];
			 if (d.getElementById(id)) {return;}
			 js = d.createElement(s); js.id = id;
			 js.src = "//connect.facebook.net/en_US/sdk.js";
			 fjs.parentNode.insertBefore(js, fjs);
		   }(document, 'script', 'facebook-jssdk'));

		/* end share */		
		
		cookie.save("total",0);
		cookie.save("left",0);
		cookie.save("RealMatters",0);
		cookie.save("Lifestyle",0);
		cookie.save("Delightful",0);
		cookie.save("Beauty",0);
		
	$('body').removeClass('body-wrap');		
	$('body').append('<div class="preloader"><div class="center"><div class="bar"><div class="progress-bar" ></div></div><div class="cross">Loading Quiz...</div></div></div>');
	
    setTimeout(function() {
		$('.preloader').hide(); 
		var parent = $(".stack");
		var divs = parent.children();
		while (divs.length) {
			parent.append(divs.splice(Math.floor(Math.random() * divs.length), 1)[0]);
		}		
	}, 3500);
	setTimeout(function() {
		$('.card:nth-last-child(1)').css({marginTop: "-12px"});
		$('.card:nth-last-child(2)').addClass('rot01');	
		$('.card:nth-last-child(3)').addClass('rot02');
	}, 6000);	
	setTimeout(function() {
		$('.card:nth-child(1)').addClass('rot1');	
		$('.card:nth-child(2)').addClass('rot2');
		$('.card:nth-child(3)').addClass('rot3');	
		$('.card:nth-child(4)').addClass('rot4');
		$('.card:nth-child(5)').addClass('rot5');
	}, 6200);	
	setTimeout(function() {
		$('.card').removeClass('cds');
	}, 6400);	
	setTimeout(function() {
	$('.card:nth-child(20)').addClass('cds cdsv');
	}, 5500);
	setTimeout(function() {
	$('.card:nth-child(19)').addClass('cds cdsv'); 
	}, 5400);
	setTimeout(function() {
	$('.card:nth-child(18)').addClass('cds cdsv');
	}, 5300);
	setTimeout(function() {
	$('.card:nth-child(17)').addClass('cds cdsv'); 
	}, 5200);
	setTimeout(function() {
	$('.card:nth-child(16)').addClass('cds cdsv'); 
	}, 5100);
	setTimeout(function() {
	$('.card:nth-child(15)').addClass('cds cdsv'); 
	}, 5000);
	setTimeout(function() {
	$('.card:nth-child(14)').addClass('cds cdsv'); 
	}, 4900);
	setTimeout(function() {
	$('.card:nth-child(13)').addClass('cds cdsv'); 
	}, 4800);
	setTimeout(function() {
	$('.card:nth-child(12)').addClass('cds cdsv'); 
	}, 4700);
	setTimeout(function() {
	$('.card:nth-child(11)').addClass('cds cdsv'); 
	}, 4600);
	setTimeout(function() {
	$('.card:nth-child(10)').addClass('cds cdsv'); 
	}, 4500);
	setTimeout(function() {
	$('.card:nth-child(9)').addClass('cds cdsv'); 
	}, 4400);
	setTimeout(function() {
	$('.card:nth-child(8)').addClass('cds cdsv'); 
	}, 4300);
	setTimeout(function() {
	$('.card:nth-child(7)').addClass('cds cdsv'); 
	}, 4200);
	setTimeout(function() {
	$('.card:nth-child(6)').addClass('cds cdsv'); 
	}, 4100);
	setTimeout(function() {
	$('.card:nth-child(5)').addClass('cds cdsv'); 
	}, 4000);	
	setTimeout(function() {
	$('.card:nth-child(4)').addClass('cds cdsv'); 
	}, 3900);	
	setTimeout(function() {
	$('.card:nth-child(3)').addClass('cds cdsv'); 
	}, 3800);
	setTimeout(function() {
	$('.card:nth-child(2)').addClass('cds cdsv'); 
	}, 3700);	
	setTimeout(function() {
	$('.card:nth-child(1)').addClass('cds cdsv'); 
	}, 3600);
			
	setTimeout(function() {
	$('.yes').addClass('ys'); 
	}, 3800);		
	setTimeout(function() {
	$('.no').addClass('not'); 
	}, 3800);	
	
	
	
	
  } 		

    copyCurrentURL() {
	var dummy = document.createElement('input'),
		text = window.location.href;
	document.body.appendChild(dummy);
	dummy.value = text;
	dummy.select();
	document.execCommand('copy');
	document.body.removeChild(dummy);
	$(".copied").fadeIn().delay(1000).fadeOut();
 
}  

	
  changeDefaultColor(){
	var color = "#efefef";
	var dom = document.getElementById('mainHolder');
	dom.style.background = color;		
  }
  
  cardhover(){
	var last_visible_element = $('.card:visible:last');
	//var rr = $(event.target).attr("class");
	var rotatevalue = last_visible_element.attr("class");  
	var rotate = rotatevalue.split(" ").pop();
	//console.log(rotate);
	if(rotate == 'rot01'){
		$('.card').removeClass('rot01');
	}
	else if(rotate == 'rot02'){
		$('.card').removeClass('rot02');
	}
	else if(rotate == 'rot03'){
		$('.card').removeClass('rot03');
	}
	else if(rotate == 'rot1'){
		$('.card').removeClass('rot1');
	}
	else if(rotate == 'rot2'){
		$('.card').removeClass('rot2');
	}	
	else if(rotate == 'rot3'){
		$('.card').removeClass('rot3');
	}	
	else if(rotate == 'rot4'){
		$('.card').removeClass('rot4');
	}
	else if(rotate == 'rot5'){
		$('.card').removeClass('rot5');
	}
  }
  mouseOver() {
 	var last_visible_element = $('.card:visible:last');
	const newtarget = last_visible_element.attr("data-lang");	
	$('.yes .circle').css({borderColor:''+ newtarget +'', background:'#fff', color:''+ newtarget +''});
	//$('.yes .arrow').css({background:''+ newtarget +''});	
  }
  mouseOut() {
    $('.circle').css({borderColor:'#57585bd1', background:'', color:'#57585bd1'});
  }
  hoverIn() {
 	var last_visible_element = $('.card:visible:last');
	const newtarget = last_visible_element.attr("data-lang");
	$('.no .circle').css({borderColor:''+ newtarget +'', background:'#fff', color:''+ newtarget +''});
  }

  
  changeColor(event){
	var color = $(event.target).attr("data-lang");
	var col = "#efefef";
	var orientation = '-10deg';
	var dom = document.getElementById('mainHolder');
	var widt = $(window).width();
		dom.style.background =color;
		dom.style.transform = 'skew('+ orientation +')';
		dom.style.left = '-15%';
		dom.style.width = '60%';
  }
 
  animateColor(event){	

	var color1 = $(event.target).attr("data-lang");
	var offsetvalue = Math.abs(event.offset);
	var orientation = '-10deg';
	var dom = document.getElementById('mainHolder');
	var color1per = '';	
	var color3per = '';	
	var widt = $(window).width();
	var col = "#efefef";
	
	if(event.offset > 0){
		dom.style.transform = 'skew('+ orientation +')';
		dom.style.left = '-15%';
		dom.style.background =color1;	
				
		if(offsetvalue > 300){
			color1per = '130%';
		}else if(offsetvalue > 296 && offsetvalue <= 300){
			color1per = '125%';
		}else if(offsetvalue > 292 && offsetvalue <= 296){
			color1per = '120%';
		}else if(offsetvalue > 288 && offsetvalue <= 292){
			color1per = '118%';
		}else if(offsetvalue > 284 && offsetvalue <= 288){		 
			color1per = '116%';
		}else if(offsetvalue > 280 && offsetvalue <= 284){
			color1per = '114%';
		}else if(offsetvalue > 276 && offsetvalue <= 280){
			color1per = '112%';
		}else if(offsetvalue > 272 && offsetvalue <= 276){
			color1per = '110%';
		}else if(offsetvalue > 268 && offsetvalue <= 272){
			color1per = '108%';
		}else if(offsetvalue > 264 && offsetvalue <= 268){
			color1per = '106%';
		}else if(offsetvalue > 260 && offsetvalue <= 264){
			color1per = '104%';
		}else if(offsetvalue > 256 && offsetvalue <= 260){
			color1per = '102%';
		}else if(offsetvalue > 252 && offsetvalue <= 256){
			color1per = '100%';
		}else if(offsetvalue > 248 && offsetvalue <= 252){
			color1per = '99%';
		}else if(offsetvalue > 244 && offsetvalue <= 248){
			color1per = '98%';
		}else if(offsetvalue > 240 && offsetvalue <= 244){
			color1per = '97%';
		}else if(offsetvalue > 236 && offsetvalue <= 240){
			color1per = '96%';
		}else if(offsetvalue > 232 && offsetvalue <= 236){
			color1per = '95%';
		}else if(offsetvalue > 228 && offsetvalue <= 232){
			color1per = '94%';
		}else if(offsetvalue > 224 && offsetvalue <= 228){
			color1per = '93%';
		}else if(offsetvalue > 220 && offsetvalue <= 224){
			color1per = '92%';
		}else if(offsetvalue > 216 && offsetvalue <= 220){
			color1per = '91%';
		}else if(offsetvalue > 212 && offsetvalue <= 216){
			color1per = '90%';
		}else if(offsetvalue > 208 && offsetvalue <= 212){
			color1per = '90%';
		}else if(offsetvalue > 204 && offsetvalue <= 208){
			color1per = '89%';
		}else if(offsetvalue > 200 && offsetvalue <= 204){
			color1per = '89%';
		}else if(offsetvalue > 196 && offsetvalue <= 200){
			color1per = '88%';
		}else if(offsetvalue > 192 && offsetvalue <= 196){
			color1per = '88%';
		}else if(offsetvalue > 188 && offsetvalue <= 192){
			color1per = '87%';
		}else if(offsetvalue > 184 && offsetvalue <= 188){
			color1per = '87%';
		}else if(offsetvalue > 180 && offsetvalue <= 184){
			color1per = '86%';
		}else if(offsetvalue > 176 && offsetvalue <= 180){
			color1per = '86%';
		}else if(offsetvalue > 172 && offsetvalue <= 176){
			color1per = '85%';
		}else if(offsetvalue > 168 && offsetvalue <= 172){
			color1per = '85%';
		}else if(offsetvalue > 164 && offsetvalue <= 168){
			color1per = '84%';
		}else if(offsetvalue > 160 && offsetvalue <= 164){
			color1per = '84%';
		}else if(offsetvalue > 156 && offsetvalue <= 160){
			color1per = '83%';
		}else if(offsetvalue > 152 && offsetvalue <= 156){
			color1per = '83%';
		}else if(offsetvalue > 148 && offsetvalue <= 152){
			color1per = '82%';
		}else if(offsetvalue > 144 && offsetvalue <= 148){
			color1per = '82%';
		}else if(offsetvalue > 140 && offsetvalue <= 144){
			color1per = '81%';
		}else if(offsetvalue > 136 && offsetvalue <= 140){
			color1per = '81%';
		}else if(offsetvalue > 132 && offsetvalue <= 136){
			color1per = '80%';
		}else if(offsetvalue > 128 && offsetvalue <= 132){
			color1per = '80%';
		}else if(offsetvalue > 124 && offsetvalue <= 128){
			color1per = '79%';
		}else if(offsetvalue > 120 && offsetvalue <= 124){
			color1per = '79%';
		}else if(offsetvalue > 116 && offsetvalue <= 120){
			color1per = '78%';
		}else if(offsetvalue > 112 && offsetvalue <= 116){
			color1per = '78%';
		}else if(offsetvalue > 108 && offsetvalue <= 112){
			color1per = '77%';
		}else if(offsetvalue > 104 && offsetvalue <= 108){
			color1per = '77%';
		}else if(offsetvalue > 100 && offsetvalue <= 104){
			color1per = '76%';
		}else if(offsetvalue > 96 && offsetvalue <= 100){
			color1per = '76%';
		}else if(offsetvalue > 92 && offsetvalue <= 96){
			color1per = '75%';
		}else if(offsetvalue > 88 && offsetvalue <= 92){
			color1per = '75%';
		}else if(offsetvalue > 84 && offsetvalue <= 88){
			color1per = '74%';
		}else if(offsetvalue > 80 && offsetvalue <= 84){
			color1per = '74%';
		}else if(offsetvalue > 76 && offsetvalue <= 80){
			color1per = '73%';
		}else if(offsetvalue > 72 && offsetvalue <= 76){
			color1per = '73%';
		}else if(offsetvalue > 68 && offsetvalue <= 72){
			color1per = '72%';
		}else if(offsetvalue > 64 && offsetvalue <= 68){
			color1per = '72%';
		}else if(offsetvalue > 60 && offsetvalue <= 64){
			color1per = '71%';
		}else if(offsetvalue > 56 && offsetvalue <= 60){
			color1per = '71%';
		}else if(offsetvalue > 52 && offsetvalue <= 56){
			color1per = '70%';
		}else if(offsetvalue > 48 && offsetvalue <= 52){
			color1per = '70%';
		}else if(offsetvalue > 44 && offsetvalue <= 48){
			color1per = '70%';
		}else if(offsetvalue > 40 && offsetvalue <= 44){
			color1per = '69%';
		}else if(offsetvalue > 36 && offsetvalue <= 40){
			color1per = '69%';
		}else if(offsetvalue > 32 && offsetvalue <= 36){
			color1per = '68%';
		}else if(offsetvalue > 28 && offsetvalue <= 32){
			color1per = '67%';
		}else if(offsetvalue > 24 && offsetvalue <= 28){
			color1per = '66%';
		}else if(offsetvalue > 20 && offsetvalue <= 24){
			color1per = '65%';
		}else if(offsetvalue > 16 && offsetvalue <= 20){
			color1per = '64%';
		}else if(offsetvalue > 12 && offsetvalue <= 16){
			color1per = '63%';
		}else if(offsetvalue > 8 && offsetvalue <= 12){
			color1per = '62%';
		}else if(offsetvalue > 4 && offsetvalue <= 8){
			color1per = '61%';
		}else if(offsetvalue > 0 && offsetvalue <= 4){
			color1per = '60%';
		}				
		dom.style.width = color1per;		
	}	
	else{
		dom.style.transform = 'skew('+ orientation +')';
		dom.style.left = '-15%';
		dom.style.background =color1;
		
		if(offsetvalue > 300){
			color1per = '0%';
		}else if(offsetvalue > 296 && offsetvalue <= 300){
			color1per = '1%';
		}else if(offsetvalue > 292 && offsetvalue <= 296){
			color1per = '2%';
		}else if(offsetvalue > 288 && offsetvalue <= 292){
			color1per = '3%';
		}else if(offsetvalue > 284 && offsetvalue <= 288){		 
			color1per = '4%';
		}else if(offsetvalue > 280 && offsetvalue <= 284){
			color1per = '5%';
		}else if(offsetvalue > 276 && offsetvalue <= 280){
			color1per = '5%';
		}else if(offsetvalue > 272 && offsetvalue <= 276){
			color1per = '6%';
		}else if(offsetvalue > 268 && offsetvalue <= 272){
			color1per = '6%';
		}else if(offsetvalue > 264 && offsetvalue <= 268){
			color1per = '7%';
		}else if(offsetvalue > 260 && offsetvalue <= 264){
			color1per = '7%';
		}else if(offsetvalue > 256 && offsetvalue <= 260){
			color1per = '8%';
		}else if(offsetvalue > 252 && offsetvalue <= 256){
			color1per = '8%';
		}else if(offsetvalue > 248 && offsetvalue <= 252){
			color1per = '9%';
		}else if(offsetvalue > 244 && offsetvalue <= 248){
			color1per = '9%';
		}else if(offsetvalue > 240 && offsetvalue <= 244){
			color1per = '10%';
		}else if(offsetvalue > 236 && offsetvalue <= 240){
			color1per = '10%';
		}else if(offsetvalue > 232 && offsetvalue <= 236){
			color1per = '10%';
		}else if(offsetvalue > 228 && offsetvalue <= 232){
			color1per = '11%';
		}else if(offsetvalue > 224 && offsetvalue <= 228){
			color1per = '12%';
		}else if(offsetvalue > 220 && offsetvalue <= 224){
			color1per = '13%';
		}else if(offsetvalue > 216 && offsetvalue <= 220){
			color1per = '14%';
		}else if(offsetvalue > 212 && offsetvalue <= 216){
			color1per = '15%';
		}else if(offsetvalue > 208 && offsetvalue <= 212){
			color1per = '16%';
		}else if(offsetvalue > 204 && offsetvalue <= 208){
			color1per = '17%';
		}else if(offsetvalue > 200 && offsetvalue <= 204){
			color1per = '18%';
		}else if(offsetvalue > 196 && offsetvalue <= 200){
			color1per = '19%';
		}else if(offsetvalue > 192 && offsetvalue <= 196){
			color1per = '20%';
		}else if(offsetvalue > 188 && offsetvalue <= 192){
			color1per = '20%';
		}else if(offsetvalue > 184 && offsetvalue <= 188){
			color1per = '20%';
		}else if(offsetvalue > 180 && offsetvalue <= 184){
			color1per = '21%';
		}else if(offsetvalue > 176 && offsetvalue <= 180){
			color1per = '22%';
		}else if(offsetvalue > 172 && offsetvalue <= 176){
			color1per = '23%';
		}else if(offsetvalue > 168 && offsetvalue <= 172){
			color1per = '24%';
		}else if(offsetvalue > 164 && offsetvalue <= 168){
			color1per = '25%';
		}else if(offsetvalue > 160 && offsetvalue <= 164){
			color1per = '26%';
		}else if(offsetvalue > 156 && offsetvalue <= 160){
			color1per = '27%';
		}else if(offsetvalue > 152 && offsetvalue <= 156){
			color1per = '28%';
		}else if(offsetvalue > 148 && offsetvalue <= 152){
			color1per = '29%';
		}else if(offsetvalue > 144 && offsetvalue <= 148){
			color1per = '30%';
		}else if(offsetvalue > 140 && offsetvalue <= 144){
			color1per = '30%';
		}else if(offsetvalue > 136 && offsetvalue <= 140){
			color1per = '30%';
		}else if(offsetvalue > 132 && offsetvalue <= 136){
			color1per = '31%';
		}else if(offsetvalue > 128 && offsetvalue <= 132){
			color1per = '32%';
		}else if(offsetvalue > 124 && offsetvalue <= 128){
			color1per = '33%';
		}else if(offsetvalue > 120 && offsetvalue <= 124){
			color1per = '34%';
		}else if(offsetvalue > 116 && offsetvalue <= 120){
			color1per = '35%';
		}else if(offsetvalue > 112 && offsetvalue <= 116){
			color1per = '36%';
		}else if(offsetvalue > 108 && offsetvalue <= 112){
			color1per = '37%';
		}else if(offsetvalue > 104 && offsetvalue <= 108){
			color1per = '38%';
		}else if(offsetvalue > 100 && offsetvalue <= 104){
			color1per = '39%';
		}else if(offsetvalue > 96 && offsetvalue <= 100){
			color1per = '40%';
		}else if(offsetvalue > 92 && offsetvalue <= 96){
			color1per = '40%';
		}else if(offsetvalue > 88 && offsetvalue <= 92){
			color1per = '40%';
		}else if(offsetvalue > 84 && offsetvalue <= 88){
			color1per = '41%';
		}else if(offsetvalue > 80 && offsetvalue <= 84){
			color1per = '42%';
		}else if(offsetvalue > 76 && offsetvalue <= 80){
			color1per = '43%';
		}else if(offsetvalue > 72 && offsetvalue <= 76){
			color1per = '44%';
		}else if(offsetvalue > 68 && offsetvalue <= 72){
			color1per = '45%';
		}else if(offsetvalue > 64 && offsetvalue <= 68){
			color1per = '46%';
		}else if(offsetvalue > 60 && offsetvalue <= 64){
			color1per = '47%';
		}else if(offsetvalue > 56 && offsetvalue <= 60){
			color1per = '48%';
		}else if(offsetvalue > 52 && offsetvalue <= 56){
			color1per = '49%';
		}else if(offsetvalue > 48 && offsetvalue <= 52){
			color1per = '50%';
		}else if(offsetvalue > 44 && offsetvalue <= 48){
			color1per = '50%';
		}else if(offsetvalue > 40 && offsetvalue <= 44){
			color1per = '50%';
		}else if(offsetvalue > 36 && offsetvalue <= 40){
			color1per = '51%';
		}else if(offsetvalue > 32 && offsetvalue <= 36){
			color1per = '52%';
		}else if(offsetvalue > 28 && offsetvalue <= 32){
			color1per = '53%';
		}else if(offsetvalue > 24 && offsetvalue <= 28){
			color1per = '54%';
		}else if(offsetvalue > 20 && offsetvalue <= 24){
			color1per = '55%';
		}else if(offsetvalue > 16 && offsetvalue <= 20){
			color1per = '56%';
		}else if(offsetvalue > 12 && offsetvalue <= 16){
			color1per = '57%';
		}else if(offsetvalue > 8 && offsetvalue <= 12){
			color1per = '58%';
		}else if(offsetvalue > 4 && offsetvalue <= 8){
			color1per = '59%';
		}else if(offsetvalue > 0 && offsetvalue <= 4){
			color1per = '60%';
		}
		dom.style.width = color1per;
	}	
	
	
	
  }
 
   // throwOut Method
   throwCardLeft() {
    // ReactSwing Card Directions 

    
	var last_visible_element = $('.card:visible:last');
	var rotatevalue = last_visible_element.attr("class");  
	var rotate = rotatevalue.split(" ").pop();
	if(rotate == 'rot01'){
		$('.card').removeClass('rot01');
	}
	else if(rotate == 'rot02'){
		$('.card').removeClass('rot02');
	}
	else if(rotate == 'rot03'){
		$('.card').removeClass('rot03');
	}
	else if(rotate == 'rot1'){
		$('.card').removeClass('rot1');
	}
	else if(rotate == 'rot2'){
		$('.card').removeClass('rot2');
	}	
	else if(rotate == 'rot3'){
		$('.card').removeClass('rot3');
	}	
	else if(rotate == 'rot4'){
		$('.card').removeClass('rot4');
	}
	else if(rotate == 'rot5'){
		$('.card').removeClass('rot5');
	}

    
	var last_visible_element = $('.card:visible:last');
	
	const newtarget = last_visible_element.attr("data-value");
    // ReactSwing Component Childrens
    const targetEl = this.stack.current.refs[newtarget];	

    if (targetEl) {
      // stack.getCard
      const card = this.state.stack.getCard(targetEl);
      // throwOut method call
      card.throwOut(-100, 100, Swing.DIRECTION.LEFT);
    }
}

   // throwOut Method
   throwCardRight() {
	   
	var last_visible_element = $('.card:visible:last');
	var rotatevalue = last_visible_element.attr("class");  
	var rotate = rotatevalue.split(" ").pop();
	if(rotate == 'rot01'){
		$('.card').removeClass('rot01');
	}
	else if(rotate == 'rot02'){
		$('.card').removeClass('rot02');
	}
	else if(rotate == 'rot03'){
		$('.card').removeClass('rot03');
	}
	else if(rotate == 'rot1'){
		$('.card').removeClass('rot1');
	}
	else if(rotate == 'rot2'){
		$('.card').removeClass('rot2');
	}	
	else if(rotate == 'rot3'){
		$('.card').removeClass('rot3');
	}	
	else if(rotate == 'rot4'){
		$('.card').removeClass('rot4');
	}
	else if(rotate == 'rot5'){
		$('.card').removeClass('rot5');
	}   
	   
    // ReactSwing Card Directions
	var last_visible_element = $('.card:visible:last');
	
	const newtarget = last_visible_element.attr("data-value");
    // ReactSwing Component Childrens
    const targetEl = this.stack.current.refs[newtarget];	 

    if (targetEl) {
      // stack.getCard
      const card = this.state.stack.getCard(targetEl);
      // throwOut method call
      card.throwOut(100, 100, Swing.DIRECTION.RIGHT);
    }
}

  movingCard(event){
	  
	  if(event.throwDirection.toString()==='Symbol(LEFT)'){

		var leftval = parseInt(cookie.load("left"));  
		cookie.save("left",leftval+1);

		var tag = $(event.target).attr("data-tag");
	    if(tag==='RealMatters'){
		
		var realMattersval = this.state.realMatters
		this.setState({realMatters:realMattersval+1});

		var realMattersval = parseInt(cookie.load("RealMatters"));  
		cookie.save("RealMatters",realMattersval+1);

	  }else if(tag==='Lifestyle'){
		var lifeStyleval = this.state.lifeStyle
		this.setState({lifeStyle:lifeStyleval+1});

		var lifeStyleval = parseInt(cookie.load("Lifestyle"));  
		cookie.save("Lifestyle",lifeStyleval+1);

	  }else if(tag==='Delightful'){
		var delightfulval = this.state.delightful
		this.setState({delightful:delightfulval+1});

		var delightfulval = parseInt(cookie.load("Delightful"));  
		cookie.save("Delightful",delightfulval+1);

	  }else if(tag==='Beauty'){
		var beautyval = this.state.beauty
		this.setState({beauty:beautyval+1});

		var beautyval = parseInt(cookie.load("Beauty"));  
		cookie.save("Beauty",beautyval+1);

	  }

	  }
	  
	  if(event.throwDirection.toString()==='Symbol(RIGHT)'){		 
		var rightval = this.state.right
		this.setState({right:rightval+1});		
	  }
	 
	  $(event.target).fadeOut();
	  
	  var totalval = parseInt(cookie.load("total"));  
	  cookie.save("total",totalval+1);
	  
	  $( ".dot" ).eq( totalval).addClass( "selected" );
	  this.changeDefaultColor();
	  var params = this.props.params;
	   
	  if(parseInt(cookie.load("total")) >= 20 ){
		if(parseInt(cookie.load("left")) ===0 || (parseInt(cookie.load("RealMatters")) === parseInt(cookie.load("Lifestyle")) && parseInt(cookie.load("Delightful")) === parseInt(cookie.load("Beauty")) && parseInt(cookie.load("Lifestyle"))==parseInt(cookie.load("Beauty")))){
			var redirectval = this.getRandomInt(4);
			var redirectval = parseInt(redirectval)+1;
			if(redirectval===1){
			browserHistory.push('/my-wellness-discovery/'+params.lang)
			}else if(redirectval===2){
				browserHistory.push('/my-delightful-discovery/'+params.lang)
			}else if(redirectval===3){
				browserHistory.push('/my-lifestyle-discovery/'+params.lang)
			}else if(redirectval===4){
				browserHistory.push('/my-beauty-discovery/'+params.lang)
			}

			return false;
		}
		var quizvalue = {RealMatters:parseInt(cookie.load("RealMatters")), Lifestyle:parseInt(cookie.load("Lifestyle")), Delightful:parseInt(cookie.load("Delightful")), Beauty:parseInt(cookie.load("Beauty"))};
		var maxValue = null;
		var maxValueeky = '';

		$.each( quizvalue, function( key, value ) {
			if (maxValue === null || maxValue <= value) {
				maxValue = value;
				maxValueeky = key;
			}
		});		 
		 
		if(params.lang!==undefined){
			 if(maxValueeky==='RealMatters'){
				browserHistory.push('/my-wellness-discovery/'+params.lang) 
			  }else if(maxValueeky==='Delightful'){
				browserHistory.push('/my-delightful-discovery/'+params.lang) 
			  }else if(maxValueeky==='Lifestyle'){
				browserHistory.push('/my-lifestyle-discovery/'+params.lang)
			  }else if(maxValueeky==='Beauty'){
				browserHistory.push('/my-beauty-discovery/'+params.lang) 
			  } 
		}
	 }


  }
  

  getRandomInt(max) {
	return Math.floor(Math.random() * Math.floor(max));
  }

	sharetoTwitter(){
		e.preventDefault();
		var twitterWindow = window.open('https://twitter.com/share?text=MASJ Discovery Quiz&url='+baseURL, 'twitter-popup', 'height=350,width=600');
		if(twitterWindow.focus) { twitterWindow.focus(); }
			return false;
		}
		
	sharetofacebook(){

	FB.ui({
        method: 'share_open_graph',
        action_type: 'og.shares',
        action_properties: JSON.stringify({
            object : {
               'og:url':baseURL,
               'og:title': "MASJ Discovery Quiz",
               'og:description': "MASJ Discovery Quiz",
               'og:og:image:width': '2560',
               'og:image:height': '960',
               'og:image': baseURL+"/homepage.png"
            }
        })
	});
	
}
  
  
  render() {

	var params = this.props.params;	
	var  langObject=''
	if(params.lang==undefined){
		browserHistory.push('/masj/en');
		return false;
	  }else{
		 langObject= require('./lang'+'-'+params.lang);
	  }
	
      return (
          <div >
		
		  <MetaTags>
            <title>MASJ Discovery Quiz</title>
            <meta name="description" content="Discovery Quiz." />
            <meta property="og:title" content="MASJ Discovery Quiz" />
            <meta property="og:image" content="/homepage.png" />
          </MetaTags>


			   <div className="animate-bkg" id="mainHolder"></div>
              <div id="viewport">
			  
				<div className="header">
				  <div className="container-wrap">
					  <div className="rows"> 	  
					  <div className="col-6 col-left">
					  <div className="headMenu">
					  <a href="javascript:void(0);" className="menuIcon"><img src={menu} alt="menu"/></a>
					  <a href="javascript:void(0);" className="uploadIcon"><img src={upload} alt="upload"/></a>
					  <div className="menuDropDown">
					  <ul><li><a href={cmsURL}>{langObject.lang.home}</a></li>
					  <li><a href={cmsURL}>{langObject.lang.faq}</a></li>	
					  </ul></div>
					  <div className="socialMenu">
					   <ul><li><a className="facebook-share" onClick={this.sharetofacebook.bind(this)} href="javascript:void(0);">{langObject.lang.facebook}</a></li>
					  <li><a href="javascript:void(0);" id="result01" className="twitter-share">{langObject.lang.twitter}</a></li>		
					  <li><a  onClick={this.copyCurrentURL.bind(this)} href="javascript:void(0);" ><span className="copy">{langObject.lang.copylink}</span><span className="link">{window.location.href}</span>
					  </a><span className="copied" style={{display:'none'}}>Copied</span></li>
					  </ul></div>
					  </div>
					  </div>
					  <div className="col-6 col-right">
					  <div className="questions-count">
					  <p>{langObject.lang.ans_details}</p>					   
					  <div className="dots"> 
							<div className="dot"><div className="dot-stroke"></div></div> 
							<div className="dot"><div className="dot-stroke"></div></div> 
							<div className="dot"><div className="dot-stroke"></div></div> 
							<div className="dot"><div className="dot-stroke"></div></div> 
							<div className="dot"><div className="dot-stroke"></div></div>  
							<div className="dot"><div className="dot-stroke"></div></div> 
							<div className="dot"><div className="dot-stroke"></div></div> 
							<div className="dot"><div className="dot-stroke"></div></div> 
							<div className="dot"><div className="dot-stroke"></div></div> 
							<div className="dot"><div className="dot-stroke"></div></div> 
							<div className="dot"><div className="dot-stroke"></div></div>
							<div className="dot"><div className="dot-stroke"></div></div> 
							<div className="dot"><div className="dot-stroke"></div></div> 
							<div className="dot"><div className="dot-stroke"></div></div> 
							<div className="dot"><div className="dot-stroke"></div></div>  
							<div className="dot"><div className="dot-stroke"></div></div> 
							<div className="dot"><div className="dot-stroke"></div></div> 
							<div className="dot"><div className="dot-stroke"></div></div> 
							<div className="dot"><div className="dot-stroke"></div></div> 
							<div className="dot"><div className="dot-stroke"></div></div> 							
					   </div>
					   <div className="count">Q {cookie.load("total")} / {this.state.totalavailable}</div>
					   </div>
					   </div>
					   
					  </div>      
				   </div>  
				</div>
				
									
					<div className="yesno yes" onClick={this.throwCardLeft.bind(this)} onMouseOut={() => this.mouseOut()} onMouseOver={() => this.mouseOver()}>
					<div className="arr-left">
					<div className="circle" id="circle"><span>{langObject.lang.yes}</span></div>
					<div className="arrow"></div>
					</div>
					</div>
					<div className="yesno no" onClick={this.throwCardRight.bind(this)} onMouseOut={() => this.mouseOut()} onMouseOver={() => this.hoverIn()}>
					<div className="arr-right">
					<div className="circle" id="circle"><span>{langObject.lang.no_w1}<br />{langObject.lang.no_w2}</span></div>
					<div className="arrow"></div>
					</div>
					</div>	
					
                      {/*Swing Element*/}
					  
                  <Swing
                      className="stack"
                      tagName="div"
                      setStack={(stack)=> this.setState({stack})}
                      ref={this.stack}
					  throwout={(e)=>this.movingCard(e)}
					  dragstart={(e)=>this.changeColor(e)}
					  dragend={(e)=>this.changeDefaultColor()}
					  dragmove={(e)=>this.animateColor(e)}      
                  >

				  {/*children elements is will be Card*/}
				
				<div className="card cds20" onMouseOver={() => this.cardhover()} data-tag="RealMatters" data-value="0" data-lang="#fda487" id="card20">
				<div className="cord-color">
				<div className="card-img"><img src={AI_20} alt="card20"/></div>
				<div className="card-question">{langObject.lang.card20}</div>
				</div>
				</div>
				
				<div className="card cds19" onMouseOver={() => this.cardhover()} data-tag="RealMatters" data-value="1" data-lang="#d0a786" id="card19">
				<div className="cord-color">
				<div className="card-img"><img src={AI_19} alt="card19"/></div>
				<div className="card-question">{langObject.lang.card19}</div>
				</div>
				</div>
				
				<div className="card cds18" onMouseOver={() => this.cardhover()} data-tag="RealMatters" data-value="2" data-lang="#f9a960" id="card18">
				<div className="cord-color">
				<div className="card-img"><img src={AI_18} alt="card18"/></div>
				<div className="card-question">{langObject.lang.card18}</div>
				</div>
				</div>
				
				<div className="card cds17" onMouseOver={() => this.cardhover()} data-tag="RealMatters" data-value="3" data-lang="#f7de8c" id="card17">
				<div className="cord-color">
				<div className="card-img"><img src={AI_17} alt="card17"/></div>
				<div className="card-question">{langObject.lang.card17}</div>
				</div>
				</div>
				
				<div className="card cds16" onMouseOver={() => this.cardhover()} data-tag="RealMatters" data-value="4" data-lang="#63caba" id="card16">
				<div className="cord-color">
				<div className="card-img"><img src={AI_16} alt="card16"/></div>
				<div className="card-question">{langObject.lang.card16}</div>
				</div>
				</div>
				
				<div className="card cds15" onMouseOver={() => this.cardhover()} data-tag="Delightful" data-value="5" data-lang="#c8d8ec" id="card15">
				<div className="cord-color">
				<div className="card-img"><img src={AI_15} alt="card15"/></div>
				<div className="card-question">{langObject.lang.card15}</div>
				</div>
				</div>
				
				<div className="card cds14" onMouseOver={() => this.cardhover()} data-tag="Delightful" data-value="6" data-lang="#e7a9b8" id="card14">
				<div className="cord-color">
				<div className="card-img"><img src={AI_14} alt="card14"/></div>
				<div className="card-question">{langObject.lang.card14}</div>
				</div>
				</div>
				
				<div className="card cds13" onMouseOver={() => this.cardhover()} data-tag="Delightful" data-value="7" data-lang="#c5a6e2" id="card13">
				<div className="cord-color">
				<div className="card-img"><img src={AI_13} alt="card13"/></div>
				<div className="card-question">{langObject.lang.card13}</div>
				</div>
				</div>
				
				<div className="card cds12" onMouseOver={() => this.cardhover()} data-tag="Delightful" data-value="8" data-lang="#f9a960" id="card12">
				<div className="cord-color">
				<div className="card-img"><img src={AI_12} alt="card12"/></div>
				<div className="card-question">{langObject.lang.card12}</div>
				</div>
				</div>
				
				<div className="card cds11" onMouseOver={() => this.cardhover()} data-tag="Delightful" data-value="9" data-lang="#d0a786" id="card11">
				<div className="cord-color">
				<div className="card-img"><img src={AI_11} alt="card11"/></div>
				<div className="card-question">{langObject.lang.card11}</div>
				</div>
				</div>
				
				<div className="card cds10" onMouseOver={() => this.cardhover()} data-tag="Beauty" data-value="10" data-lang="#f5bdc5" id="card10">
				<div className="cord-color">
				<div className="card-img"><img src={AI_10} alt="card10"/></div>
				<div className="card-question">{langObject.lang.card10}</div>
				</div>
				</div>
				
				<div className="card cds9" onMouseOver={() => this.cardhover()} data-tag="Beauty" data-value="11" data-lang="#fda487" id="card9">
				<div className="cord-color">
				<div className="card-img"><img src={AI_9} alt="card9"/></div>
				<div className="card-question">{langObject.lang.card9}</div>
				</div>
				</div>
				
				<div className="card cds8" onMouseOver={() => this.cardhover()} data-tag="Beauty" data-value="12" data-lang="#c8d8ec" id="card8">
				<div className="cord-color">
				<div className="card-img"><img src={AI_8} alt="card8"/></div>
				<div className="card-question">{langObject.lang.card8}</div>
				</div>
				</div>
				
				<div className="card cds7" onMouseOver={() => this.cardhover()} data-tag="Beauty" data-value="13" data-lang="#63caba" id="card7">
				<div className="cord-color">
				<div className="card-img"><img src={AI_7} alt="card7"/></div>
				<div className="card-question">{langObject.lang.card7}</div>
				</div>
				</div>
				
				<div className="card cds6" onMouseOver={() => this.cardhover()} data-tag="Beauty" data-value="14" data-lang="#d0a786" id="card6">
				<div className="cord-color">
				<div className="card-img"><img src={AI_6} alt="card6"/></div>
				<div className="card-question">{langObject.lang.card6}</div>
				</div>
				</div>
				
				<div className="card cds5" onMouseOver={() => this.cardhover()} data-tag="Lifestyle" data-value="15" data-lang="#c5a6e2" id="card5">
				<div className="cord-color">
				<div className="card-img"><img src={AI_5} alt="card5"/></div>
				<div className="card-question">{langObject.lang.card5}</div>
				</div>
				</div>
				
				<div className="card cds4" onMouseOver={() => this.cardhover()} data-tag="Lifestyle" data-value="16" data-lang="#c8848f" id="card4">
				<div className="cord-color">
				<div className="card-img"><img src={AI_4} alt="card4"/></div>
				<div className="card-question">{langObject.lang.card4}</div>
				</div>
				</div>
				
				<div className="card cds3" onMouseOver={() => this.cardhover()} data-tag="Lifestyle" data-value="17" data-lang="#f7de8c" id="card3">
				<div className="cord-color">
				<div className="card-img"><img src={AI_3} alt="card3"/></div>
				<div className="card-question">{langObject.lang.card3}</div>
				</div> 
				</div>	
			  
				<div className="card cds2" onMouseOver={() => this.cardhover()} data-tag="Lifestyle" data-value="18" data-lang="#f9a960" id="card2">
				<div className="cord-color">
				<div className="card-img"><img src={AI_2} alt="card2"/></div>
				<div className="card-question">{langObject.lang.card2}</div>
				</div> 
				</div>			
				
				<div className="card cds1" onMouseOver={() => this.cardhover()} data-tag="Lifestyle" data-value="19" data-lang="#63caba" id="card1">				
				<div className="cord-color">
				<div className="card-img"><img src={AI_1} alt="card1"/></div>
				<div className="card-question">{langObject.lang.card1}</div>
				</div> 
				</div>				
					  
                  </Swing>
              </div>
             
          </div>
      )
  }
}

export default Home;



// WEBPACK FOOTER //
// ./src/Home.js